var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{opacity:0;}.c{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177 -5514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.5,15.144H14.225V11.221A5.526,5.526,0,0,1,15.85,7.3a5.47,5.47,0,0,1,7.8,0,5.526,5.526,0,0,1,1.625,3.923h0s-.006,3.933,0,3.923H27.55V11.221h0a7.8,7.8,0,1,0-15.6.106v3.817H10a3.269,3.269,0,0,0-3.25,3.269V34.105A3.269,3.269,0,0,0,10,37.374H29.5a3.269,3.269,0,0,0,3.25-3.269V18.413A3.269,3.269,0,0,0,29.5,15.144Zm-8.612,10.2v5.623a1.169,1.169,0,0,1-1.081,1.177A1.142,1.142,0,0,1,18.613,31V25.344a2.6,2.6,0,1,1,2.275,0Z",
    transform: "translate(177.25 5513.626)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(217 5554) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V39H39V1H1M0,0H40V40H0Z",
    transform: "translate(217 5554) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.63abe2dd8e944ff3d4e7defab3c4f0a7.svg";
export { ForwardRef as ReactComponent };